import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import PracticeTestLayout from '../components/Layout/PracticeTestLayout';
import { setIsStartTest } from '../redux/Slices/QuestionsSlice';
import { setCompleteTestData } from '../redux/Slices/StartTestSlice/completeTestData';
import {
  ExamPattern,
  setNewTemplete
} from '../redux/Slices/StartTestSlice/newTemplete';
import {
  setAllSectionsData,
  setCurrentTime,
  setHasReadRoundInsructions,
  setShowInstructions,
  //   setUserSelectedCompanyTest,
  setUserTestId
} from '../redux/Slices/StartTestSlice/startFulTest';
import {
  useGetAllSectionsDataQuery,
  useGetMockTestMutation
} from '../services/startTestAPI/startTestApi';

const MockTest = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const { id } = params;
  const { data: sectionsData, error: sectionsError } =
    useGetAllSectionsDataQuery({});

  const [getMockTest, { data: mockTestResponse, isLoading: mockTestLoading }] =
    useGetMockTestMutation();

  const fetchMockTestData = async () => {
    let examData: ExamPattern;
    try {
      const response = await getMockTest({ userId: id }).unwrap();
      const examData = {
        ...response?.data?.mockTestDTO?.examPatternDTO,
        rounds: response?.data?.mockTestDTO?.examPatternDTO?.rounds?.map(
          (round: any) => ({
            ...round,
            sections: [...round.sections]?.sort(
              (a, b) => a?.sectionSortOrder - b?.sectionSortOrder
            )
          })
        )
      };
      const shouldReadFirstSectionInstructions =
        response?.data?.mockTestDTO?.examPatternDTO?.rounds[0]?.sections[0]
          ?.isInstructionAvailabe;
      dispatch(setHasReadRoundInsructions(true));
      dispatch(setCompleteTestData([response?.data]));
      dispatch(setNewTemplete([examData]));
      dispatch(setShowInstructions(shouldReadFirstSectionInstructions));
      // dispatch(setUserSelectedCompanyTest(test));
      dispatch(setUserTestId(response.id));
      dispatch(setIsStartTest(true));
      dispatch(
        setCurrentTime(examData?.rounds[0]?.sections[0]?.sectionSpanTime)
      );
    } catch (error) {
      console.error('Error fetching mock test data:', error);
    }
  };
  useEffect(() => {
    if (!id) return;
    fetchMockTestData();
  }, []);

  useEffect(() => {
    if (sectionsData) {
      dispatch(setAllSectionsData(sectionsData.data));
    }
  }, [sectionsData]);

  return (
    <div className='h-dvh'>
      <PracticeTestLayout hideExitBtn={true} />
    </div>
  );
};

export default MockTest;
